import {observer} from "mobx-react";
import React from "react";
import {Box, Checkbox, Divider, FormControlLabel, FormGroup, TextField, Typography} from "@mui/material";
import {useStore} from "../../stores/Store";

export default observer(function ContactAreasOfInterest() {
    const {LanguageStore, ContactFormStore} = useStore();
    const {currentLanguageMessages, currentLanguage} = LanguageStore;
    const { sendFurtherInformation, contactMeForAppointment, interestedInRenting,
        setInterestedInRenting, setSendFurtherInformation, setContactMeForAppointment } = ContactFormStore;

    const handleFurtherInformationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSendFurtherInformation(event.target.checked);
    }
    const handleInterestedInRentingChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInterestedInRenting(event.target.checked);
    }
    const handleContactMeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setContactMeForAppointment(event.target.checked)
    }

    return(
        <Box>
            <Typography sx={{mt: 4}}  variant={'h6'}>{currentLanguageMessages.ContactPage.areasOfInterest.areasOfInterestTitle}</Typography>
            <Divider sx={{mb: 1}} />
            <FormGroup>
                <FormControlLabel control={
                    <Checkbox
                        checked={sendFurtherInformation}
                        onChange={handleFurtherInformationChange}
                    />
                } label={currentLanguageMessages.ContactPage.areasOfInterest.sendFurtherInformationChecboxLabel}
                />
                <FormControlLabel control={
                    <Checkbox
                        checked={contactMeForAppointment}
                        onChange={handleContactMeChange}
                    />
                } label={currentLanguageMessages.ContactPage.areasOfInterest.contactMeForTryOutCheckboxLabel}
                />
                <FormControlLabel control={
                    <Checkbox
                        checked={interestedInRenting}
                        onChange={handleInterestedInRentingChange}
                    />
                } label={currentLanguageMessages.ContactPage.areasOfInterest.interestedInRentingCheckboxLabel}
                />
            </FormGroup>
        </Box>
    )
})